import React from 'react';
import './Loader.css';

const Loader = ({ message = "Загрузка..." }) => {
  return (
    <div className="app-loader">
      <div className="app-loader-spinner"></div>
      <p className="app-loader-message">{message}</p>
    </div>
  );
};

export default Loader; 